export default __webpack_public_path__ + "static/media/205847.9021b6ec.jpg";